import React, {useState} from "react";
import {Link, useLocation} from "react-router-dom";
import {FaCopy, FaLink} from "react-icons/fa";
import {TradingchartPreview} from "./render";

export const Tradingchart = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [environment, setEnvironment] = useState(queryParams.get("environment") || "DEV");
    const [copied, setCopied] = useState(false);
    const [symbol, setSymbol] = useState(queryParams.get("symbol") || "");
const [height, setHeight] = useState(queryParams.get("height") || "450");

    const linkToCopy =
        process.env.REACT_APP_FRONT_URL + "/tradingChart?na=1"
        + "&environment=PROD"
        + "&symbol=" + symbol
        + "&height=" + height;





    const handleCopy = () => {
        navigator.clipboard.writeText(linkToCopy);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };



    return (
        <div className="flex flex-col items-center justify-center" style={{width:'100%',height:'100%',}}>
            {environment=== "DEV" && (
                <>
                    <h1 style={{fontSize: 40, fontWeight: 'bold'}}>
                        Trading Chart
                    </h1>
                    <br/><br/>
                    <h3 className="text-lg font-semibold mb-3">QUERY PARAMETERS</h3>
                    <br/>

                    <h3 className="text-md font-semibold mb-3 mt-10">Chart configuration</h3>
                    <div className="flex flex-wrap items-start justify-start gap-4 w-full">

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">symbol</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Ticker del instrumento
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setSymbol(e.target.value)}
                                        value={symbol}
                                    />
                                </p>
                            </div>


                            <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                                <div className="h-full px-6 py-4 flex flex-col">
                                    <div className="font-bold text-xl mb-2">height</div>
                                    <p className="text-gray-700 text-base flex-grow">
                                        Alto de la gráfica
                                        <br/>
                                        <input
                                            type="text"
                                            className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                            onChange={(e) => setHeight(e.target.value)}
                                            value={height}
                                        />
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                    <h3 className="text-lg font-semibold mb-3">PREVIEW</h3>
                    <br/><br/>

                </>
            )}

            <TradingchartPreview symbol={symbol} height={height}/>


            {environment === "DEV" && (
                <div>
                    <br/><br/>
                    <div className="flex items-center mb-5">
                        <button
                            onClick={handleCopy}
                            className="mr-4 bg-blue-500 text-white p-2 rounded-lg flex items-center hover:bg-blue-600"
                        >
                            <FaCopy className="mr-2"/>
                            {copied ? "Copied!" : "Copy Link"}
                        </button>
                        <Link to={"/"}>
                            <button
                                className="mr-4 bg-blue-500 text-white p-2 rounded-lg flex items-center hover:bg-blue-600">
                                <FaLink className="mr-2"/>
                                Go to Home
                            </button>
                        </Link>
                    </div>

                </div>
            )}
        </div>

    );
};
